
export const OPEN_PIN_FULL_VIEW_MODAL                = 'OPEN_PIN_FULL_VIEW_MODAL';
export const CLOSE_PIN_FULL_VIEW_MODAL               = 'CLOSE_PIN_FULL_VIEW_MODAL';


export const openPinFullViewModal = data => ({
    type: OPEN_PIN_FULL_VIEW_MODAL,
    data
});

export const closePinFullViewModal = () => ({
    type: CLOSE_PIN_FULL_VIEW_MODAL,
});



// WEBPACK FOOTER //
// ./src/Actions/modals.js